export function isFacebookInAppBrowser(): boolean {
  const ua = navigator.userAgent || navigator.vendor || window['opera'];
  return ua.indexOf('FBAN') > -1 || ua.indexOf('FBAV') > -1;
}

export function isInApp(): boolean {
  const ua = navigator.userAgent || navigator.vendor || window['opera'];
  const rules = ['WebView', '(iPhone|iPod|iPad)(?!.*Safari/)', 'Android.*(wv|.0.0.0)'];
  const regex = new RegExp(`(${rules.join('|')})`, 'ig');
  return Boolean(ua.match(regex));
}

/**
 * This function handles opening external links in a consistent way
 */
export function openExternalLink(url: string): void {
  window.open(url, isInApp() ? '_self' : '_blank');
}

export function openNewBrowserTab(url: string): void {
  window.open(url, isInApp() ? '_self' : '_blank');
}

const noPrintClassName = 'no-print';
const printClassName = 'print';

export function printElement(elem) {
  const printContents = elem.innerHTML;

  Array.from(document.body.children).forEach(child => child.classList.add(noPrintClassName));

  const div = document.createElement('div');
  div.innerHTML = printContents;
  div.className = printClassName;

  document.body.append(div);

  setTimeout(function () {
    window.print();
    document.body.removeChild(div);
    Array.from(document.body.children).forEach(child => child.classList.remove(noPrintClassName));
  }, 250);
}
